import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, Col, Container, Form, Label, Row, FormFeedback, InputGroup, Input } from 'reactstrap'
import { Btn, H6, P } from '../../AbstractElements'
import PlanHeader from '../../Components/settings/PlansAndPricingComponent/CreatePlan/ValidationForm/PlanHeader'
import { Errors, GroupsInterface, isValidEmail, isValidPassword, UserDetails } from './interface'
import axiosInstance from '../../Utils/axiosInstance'
import { backendbaseUrl } from '../../Utils/baseUrl'
import Select from "react-select";
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import { OptionType } from '../../Types/Forms.type'
import { toast } from 'react-toastify';

import "./button3.css"
import { useNavigate } from 'react-router-dom'
// const existingUsers = [
//     { value: "John Doe", label: "John Doe" },
//     { value: "Jane Smith", label: "Jane Smith" },
//     { value: "Alice Johnson", label: "Alice Johnson" },
// ];



function CompanyUserManagement() {
    const [errors, setErrors] = useState<Errors>({})
    const [validate, setValidate] = useState(false);
    const [formData, setFormData] = useState<UserDetails>({ userName: '', email: '', password: '', groupName: '', selectedApps: [], permissions: [] })
    const [availableUserCount, setAvailableUserCount] = useState<{ 'total_users': any, 'available_users': any }>({ 'total_users': '', 'available_users': '' })
    const [inputValue, setInputValue] = useState("");
    const [dynamicFields, setDynamicFields] = useState<Record<string, any[]>>({});
    const [permissionChange, setPermissionChange] = useState<any>({})
    const [appOptions, setAppOptions] = useState([])
    const [groups, setgroups] = useState<GroupsInterface[]>([])
    const navigate = useNavigate();


    useEffect(() => {

        const groupsList = async () => {

            try {

                const response = await axiosInstance.get(`${backendbaseUrl}/company/user/groups/`);
                if (response.status === 200) {
                    console.log(response.data)

                    setgroups(response.data)

                }

            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 401) {
                        toast.error("Unauthorized");
                    } else {
                        toast.error(error.response.data.message || "An unknown error occurred");
                    }
                } else {
                    toast.error("Network error or server is down");
                }

            }

        }
        groupsList();

    }, [])









    useEffect(() => {

        const getAppsList = async () => {

            try {

                const response = await axiosInstance.get(`${backendbaseUrl}/permission/organization/default-apps`);
                if (response.status === 200) {
                    const appListData = response?.data?.map((c: { id: string, name: string }) => ({
                        value: c.id,
                        label: c.name
                    })) || [];

                    setAppOptions(appListData)

                }

            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 401) {
                        toast.error("Unauthorized");
                    } else {
                        toast.error(error.response.data.message || "An unknown error occurred");
                    }
                } else {
                    toast.error("Network error or server is down");
                }

            }

        }
        getAppsList();

    }, [])



    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
        e.preventDefault()
        let newErrors: Errors = {};
        if (!formData.userName.trim()) {
            newErrors.userName = "Please enter a valid username";
        }
         if (!isValidEmail(formData.email)) newErrors.email = "PLease enter a valid email"
        if (!isValidPassword(formData.password)) newErrors.password = "password length should be 8 characters."
        if (!formData.groupName.trim()) newErrors.groupName = "Please select a group";
        console.log(newErrors)
        console.log("form data before submiting: ", formData)
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        formData.permissions = permissionChange

        setValidate(true);

        try {
            const response = await axiosInstance.post(`${backendbaseUrl}/company/create/user/`, formData);
            if (response.status === 201 || response.status === 200) {
                toast.success("Plan created successfully!");
                setFormData({ userName: '', email: '', password: '', groupName: '', selectedApps: [], permissions: [] })

            }
            else {
                toast.error("Failed to create plan. Please try again.");
            }
        } catch (e: any) {
            console.log(e.response.status)
            if (e.response.status === 400) {
                console.log(e.response.data.message)
                toast.error(e.response?.data?.message || "An error occurred while creating the plan.");
            }
            else {
                toast.error(e.response?.data?.message || "An error occurred while creating the plan.");
            }


        }

    }

    const [selectedgroup, setSelectedgroup] = useState<any>(null);

    const handleSelectChange = (selectedOption: any) => {

        if (selectedOption) {
            setSelectedgroup(selectedOption);
            setFormData({ ...formData, groupName: selectedOption.value });
        } else {
            setSelectedgroup(null);
            setFormData({ ...formData, groupName: "" });
        }
    };



    useEffect(() => {

        const groupsApps = async () => {

            try {
                if (selectedgroup) {
                    setFormData((prevFormData) => ({ ...prevFormData, selectedApps: [] }));
                    const response = await axiosInstance.get(`${backendbaseUrl}/company/usergroup/apps/?group_name=${selectedgroup?.value}`);
                    if (response.status === 200) {
                        console.log(response.data)
                        // handleMultiSelectChange(response.data)


                    }
                }

            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 401) {

                    } else {

                    }
                } else {
                }

            }

        }
        groupsApps();

    }, [selectedgroup])

    const handleGeneratePassword = async (e: any) => {
        e.preventDefault()
        console.log('skj')
        let generatedPassord = 'error fetching'
        try {
            const response = await axiosInstance.get(`${backendbaseUrl}/users/generate-password/`)
            generatedPassord = response.data.password;
            console.log(generatedPassord)

        } catch (error) {
            console.log(error)
        }




        setFormData((prev) => ({
            ...prev, password: generatedPassord
        }))
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        console.log(formData.groupName)

        if (errors[name as keyof Error]) {
            setErrors({ ...errors, [name]: undefined });
        }


    }

    const filteredOptions = inputValue
        ? [
            ...groups.filter((g) =>
                g.label.toLowerCase().includes(inputValue.toLowerCase())
            )

        ]
        : groups;




    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {

        const { name, value } = e.target;
        let newErrors = { ...errors };

        if (!value.trim()) {
            newErrors[name as keyof Error] = `Please Enter a valid ${name}.`
        } 
        // else if (name === "userName" && !/^[a-zA-Z\s]+$/.test(value.trim())) {
        //     newErrors[name as keyof Error] = "Name should contain only letters";
        // }

        setErrors(newErrors);

    }

    const handleMultiSelectChange = async (selectedOptions: any) => {
        setFormData({ ...formData, selectedApps: selectedOptions || [] });
        if (selectedOptions.length > 0) {
            setErrors({ ...errors, selectedApps: undefined });
        }

        console.log("handleMultiSelectChange", selectedOptions)

        const selectedAppIds = selectedOptions.map((option: any) => option.value);

        console.log("selectedAppIds", selectedAppIds)
        try {
            const newFields: Record<string, any[]> = { ...dynamicFields };

            for (const appId of selectedAppIds) {
                if (!newFields[appId]) {
                    let response = await axiosInstance.get(`${backendbaseUrl}/permission/default-permissions/${appId}`);
                    if (selectedgroup) {
                        console.log("hello from selected group", selectedgroup)

                        response = await axiosInstance.get(`${backendbaseUrl}/company/assigned-permissions/apps/group/${appId}/${selectedgroup.label}`);
                    }


                    const data = response.data

                    newFields[appId] = data;
                }
            }


            console.log(newFields, "ss")
            Object.keys(newFields).forEach((key) => {
                if (!selectedAppIds.includes(key)) {
                    delete newFields[key];
                }
            });

            setDynamicFields(newFields);
        } catch (error) {
            console.error("Error fetching dynamic fields:", error);
        }

    };

    const handlePermissionChange = (
        appId: string,
        fieldId: string,
        permissionType: string,
        value: boolean,
        appName: string,
        resources: string
    ) => {
        setDynamicFields((prevFields) => {
            const updatedFields = { ...prevFields };
            const fieldIndex = updatedFields[appId].findIndex((f) => f.id === fieldId);

            if (fieldIndex !== -1) {
                updatedFields[appId][fieldIndex] = {
                    ...updatedFields[appId][fieldIndex],
                    permisssions: {
                        ...updatedFields[appId][fieldIndex].permisssions,
                        [permissionType]: value,

                    },
                };
            }

            return updatedFields; // Always return the updated object
        });
    };

    useEffect(() => {
        // Convert the object into an array
        const formattedData = Object.values(dynamicFields).flat();
        setPermissionChange(formattedData);
    }, [dynamicFields]);


    useEffect(() => {

        const getAvilableUsers = async () => {

            try {

                const response = await axiosInstance.get(`${backendbaseUrl}/company/user/availability`)
                console.log(response.data)
                setAvailableUserCount(response.data.data)
            } catch (error) {

            }

        }

        getAvilableUsers();


    }, [])



    return (
        <div className="page-body">
            <Container fluid>
                <Row>
                    <Container fluid>
                        <PlanHeader headClass='pb-4 card' title={"User Management"} subTitle={"Create new Users"} />
                    </Container>



                </Row>

                <Row>
                    <h4>Availabilty<span className="badge bg-secondary">
                        {availableUserCount.available_users}/{availableUserCount.total_users}</span>

                        <span>
                            {availableUserCount.available_users >= availableUserCount.total_users ? (
                                <button
                                    className="custom-btn btn-5"
                                    onClick={() => navigate('/company/upgrade-user/')}
                                >
                                    <span>Upgrade Plan</span>
                                </button>
                            ) : (
                                "not its not"
                            )}
                        </span>


                    </h4>

                    <Col xl={6}>


                        <Card className="height-equal">

                            <CardBody>
                                <Form className="needs-validation custom-input" onSubmit={handleSubmit}>
                                    <Row className="g-3">


                                        <Col xs={12}>
                                            <Label>Name</Label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.userName ? "is-invalid" : ""} ${validate && !errors.userName ? "is-valid" : ""
                                                    }`}
                                                placeholder="Enter the persons Name"
                                                name="userName"
                                                value={formData.userName}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.userName && <FormFeedback>{errors.userName}</FormFeedback>}
                                            {!errors.userName && validate && <FormFeedback valid>Looks good!</FormFeedback>}
                                        </Col>



                                        <Col xs={12}>
                                            <Label>email</Label>
                                            <input
                                                type="text"
                                                className={`form-control ${errors.email ? "is-invalid" : ""} ${validate && !errors.email ? "is-valid" : ""
                                                    }`}
                                                placeholder="Enter Email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {errors.email && <FormFeedback>{errors.email}</FormFeedback>}
                                            {!errors.email && validate && <FormFeedback valid>Looks good!</FormFeedback>}
                                        </Col>




                                        <Col xs={12}>
                                            <Label>Password</Label>
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.password ? "is-invalid" : ""} ${validate && !errors.password ? "is-valid" : ""}`}
                                                    placeholder="Enter the Password"
                                                    name="password"
                                                    value={formData.password}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />

                                                <button className="btn btn-primary" id="button-addon2" onClick={(e) => handleGeneratePassword(e)}>generate</button>
                                                {errors.password && <FormFeedback>{errors.password}</FormFeedback>}
                                                {!errors.password && validate && <FormFeedback valid>Looks good!</FormFeedback>}
                                            </div>

                                        </Col>

                                        <Col xs={12}>
                                            <Label>Group Name</Label>
                                            <Select
                                                options={filteredOptions}
                                                isClearable
                                                placeholder="Type to search..."
                                                value={selectedgroup}
                                                onChange={(selectedOption) => {
                                                    handleSelectChange(selectedOption);
                                                    if (selectedOption) {
                                                        setErrors({ ...errors, groupName: undefined });
                                                    }
                                                }}
                                                onInputChange={(newValue) => setInputValue(newValue)}
                                                noOptionsMessage={() => null} // Remove default "No options"
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        borderColor: errors.groupName
                                                            ? '#dc3545'
                                                            : validate && !errors.groupName && formData.groupName
                                                                ? '#198754'
                                                                : base.borderColor,
                                                        boxShadow: errors.groupName
                                                            ? '0 0 0 0.25rem rgba(220, 53, 69, 0.25)'
                                                            : validate && !errors.groupName && formData.groupName
                                                                ? '0 0 0 0.25rem rgba(25, 135, 84, 0.25)'
                                                                : base.boxShadow,
                                                        '&:hover': {
                                                            borderColor: errors.groupName
                                                                ? '#dc3545'
                                                                : validate && !errors.groupName && formData.groupName
                                                                    ? '#198754'
                                                                    : base.borderColor,
                                                        },
                                                    }),
                                                }}
                                            />
                                            {errors.groupName && (
                                                <div className="invalid-feedback d-block">{errors.groupName}</div>
                                            )}
                                            {!errors.groupName && validate && formData.groupName && (
                                                <div className="valid-feedback d-block">Looks good!</div>
                                            )}
                                            {selectedgroup === null && formData.groupName.length > 0 && (
                                                <button
                                                    type="button"
                                                    className="btn btn-secondary mt-2"
                                                    onClick={() => alert(`Creating new user: ${formData.userName}`)}
                                                >
                                                    Create "{formData.userName}"
                                                </button>
                                            )}
                                        </Col>






                                    </Row>






                                    <button type="submit" className="btn btn-primary mt-3">
                                        Submit
                                    </button>
                                </Form>

                            </CardBody>
                        </Card>
                    </Col>


                    <Col xl={6}>
                        <Card className="height-equal">

                            <CardBody>
                                <Row className="g-3">
                                    {Object.keys(dynamicFields).length === 0 ? (
                                        <div>

                                            <DotLottieReact
                                                src="https://lottie.host/c38f9e55-0add-4d20-b616-356aff2262c9/BpqVsc5Tva.lottie"
                                                loop
                                                autoplay
                                            />
                                            <p className='text-center'>Your App's Menu will appear here! once you start selecting apps......</p>
                                        </div>
                                    ) : (
                                        Object.entries(dynamicFields).map(([appId, fields]) => (
                                            <Col xs={12} key={appId}>
                                                <h4>{fields[0]?.apps.name}</h4> {/* App Name as Heading */}
                                                {fields.map((field) => (
                                                    <div key={field.id} className="mb-3">
                                                        <Label>{field.readable_name} ({field.resource})</Label> {/* Display resource */}
                                                        <div className="d-flex gap-3">
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={field.permisssions.create}
                                                                    onChange={(e) => handlePermissionChange(appId, field.id, "create", e.target.checked, fields[0]?.apps.name, field.resource)}
                                                                /> Create
                                                            </div>
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={field.permisssions.read}
                                                                    onChange={(e) => handlePermissionChange(appId, field.id, "read", e.target.checked, fields[0]?.apps.name, field.resource)}
                                                                /> Read
                                                            </div>
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={field.permisssions.update}
                                                                    onChange={(e) => handlePermissionChange(appId, field.id, "update", e.target.checked, fields[0]?.apps.name, field.resource)}
                                                                /> Update
                                                            </div>
                                                            <div>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={field.permisssions.delete}
                                                                    onChange={(e) => handlePermissionChange(appId, field.id, "delete", e.target.checked, fields[0]?.apps.name, field.resource)}
                                                                /> Delete
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </Col>
                                        ))
                                    )}




                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default CompanyUserManagement